const UNDEFINED_ICON_NAME = 'unknown-clr';
const FOLDER_ICON_NAME = 'folder-clr';
const VOLUME_ICON_NAME = 'hard-drive-clr';

const ICON_NAME = [
  'image-clr',
  'vector-clr',
  'graph-clr',
  'music-clr',
  'video-clr',
  'pdf-clr',
  'presentation-clr',
  'ppt-clr',
  'spreadsheet-clr',
  'xls-clr',
  'text-clr',
  'doc-clr',
  'archive-clr',
  'web-clr',
  'programming-clr',
  'sys-clr',
  'exe-clr',
  'disk-media-clr',
  'db-clr',
  'font-clr'
];

const EXT_ICON_ID_MAP = new Map([
  ['bmp', 0],
  ['gif', 0],
  ['ico', 0],
  ['jpeg', 0],
  ['jpg', 0],
  ['png', 0],
  ['mpng', 0],
  ['rle', 0],
  ['dib', 0],
  ['crw', 0],
  ['nef', 0],
  ['raf', 0],
  ['orf', 0],
  ['mrw', 0],
  ['dcr', 0],
  ['mos', 0],
  ['fido', 0],
  ['pcd', 0],
  ['raw', 0],
  ['pct', 0],
  ['pict', 0],
  ['sct', 0],
  ['tga', 0],
  ['targa', 0],
  ['vda', 0],
  ['wbmp', 0],
  ['wbm', 0],
  ['pcx', 0],
  ['pxr', 0],
  ['rgb', 0],
  ['rgba', 0],
  ['sgi', 0],
  ['cin', 0],
  ['dpx', 0],
  ['bw', 0],
  ['ai', 1],
  ['svg', 1],
  ['eps', 1],
  ['epsf', 1],
  ['ep', 1],
  ['cdr', 1],
  ['sketch', 1],
  ['afdesign', 1],
  ['ps', 2],
  ['psd', 2],
  ['psb', 2],
  ['pdd', 2],
  ['tif', 2],
  ['tiff', 2],
  ['sdr', 2],
  ['aif', 3],
  ['aiff', 3],
  ['cda', 3],
  ['mid', 3],
  ['midi', 3],
  ['mp3', 3],
  ['mpa', 3],
  ['ogg', 3],
  ['wav', 3],
  ['wma', 3],
  ['wpl', 3],
  ['m3u', 3],
  ['pls', 3],
  ['rmi', 3],
  ['kar', 3],
  ['miz', 3],
  ['aac', 3],
  ['apl', 3],
  ['m4a', 3],
  ['m4b', 3],
  ['vlb', 3],
  ['nsv', 3],
  ['nsa', 3],
  ['voc', 3],
  ['au', 3],
  ['sng', 3],
  ['wmx', 3],
  ['flac', 3],
  ['3g2', 4],
  ['3gp', 4],
  ['avi', 4],
  ['flv', 4],
  ['h264', 4],
  ['m4v', 4],
  ['mkv', 4],
  ['mov', 4],
  ['mp4', 4],
  ['mpeg4', 4],
  ['mpg', 4],
  ['mpeg', 4],
  ['rm', 4],
  ['swf', 4],
  ['vob', 4],
  ['wmv', 4],
  ['m1v', 4],
  ['divx', 4],
  ['xvid', 4],
  ['qt', 4],
  ['asx', 4],
  ['wpl', 4],
  ['wvx', 4],
  ['dvr-ms', 4],
  ['asf', 4],
  ['flc', 4],
  ['fli', 4],
  ['flic', 4],
  ['pdf', 5],
  ['pdp', 5],
  ['key', 6],
  ['odp', 6],
  ['pps', 7],
  ['ppt', 7],
  ['pptx', 7],
  ['ppsx', 7],
  ['pot', 7],
  ['potx', 7],
  ['ods', 8],
  ['numbers', 8],
  ['xls', 9],
  ['xlsx', 9],
  ['xl', 9],
  ['xlr', 9],
  ['xlt', 9],
  ['xltx', 9],
  ['xlw', 9],
  ['xla', 9],
  ['xlb', 9],
  ['txt', 10],
  ['tex', 10],
  ['odt', 10],
  ['rtf', 10],
  ['wks', 10],
  ['wps', 10],
  ['wpd', 10],
  ['pages', 10],
  ['doc', 11],
  ['docx', 11],
  ['dotx', 11],
  ['dot', 11],
  ['7z', 12],
  ['arj', 12],
  ['deb', 12],
  ['pkg', 12],
  ['rar', 12],
  ['rpm', 12],
  ['tar', 12],
  ['gz', 12],
  ['z', 12],
  ['zip', 12],
  ['asp', 13],
  ['aspx', 13],
  ['cer', 13],
  ['cfm', 13],
  ['cgi', 13],
  ['pl', 13],
  ['css', 13],
  ['htm', 13],
  ['html', 13],
  ['js', 13],
  ['jsp', 13],
  ['part', 13],
  ['php', 13],
  ['py', 13],
  ['rss', 13],
  ['xhtml', 13],
  ['xht', 13],
  ['mht', 13],
  ['mhtml', 13],
  ['xhtml', 13],
  ['xhtm', 13],
  ['c', 14],
  ['class', 14],
  ['cpp', 14],
  ['cs', 14],
  ['h', 14],
  ['java', 14],
  ['sh', 14],
  ['swift', 14],
  ['vb', 14],
  ['bak', 15],
  ['cab', 15],
  ['cfg', 15],
  ['cpl', 15],
  ['cur', 15],
  ['dll', 15],
  ['dmp', 15],
  ['drv', 15],
  ['icns', 15],
  ['ini', 15],
  ['lnk', 15],
  ['msi', 15],
  ['sys', 15],
  ['tmp', 15],
  ['apk', 16],
  ['bat', 16],
  ['bin', 16],
  ['cgi', 16],
  ['pl', 16],
  ['com', 16],
  ['exe', 16],
  ['gadget', 16],
  ['jar', 16],
  ['py', 16],
  ['wsf', 16],
  ['bin', 17],
  ['dmg', 17],
  ['iso', 17],
  ['toast', 17],
  ['vcd', 17],
  ['csv', 18],
  ['dat', 18],
  ['db', 18],
  ['dbf', 18],
  ['log', 18],
  ['mdb', 18],
  ['sav', 18],
  ['sql', 18],
  ['tar', 18],
  ['xml', 18],
  ['fnt', 19],
  ['fon', 19],
  ['otf', 19],
  ['ttf', 19]
]);

function getFullSvgIconName(iconName) {
  return `svg-${iconName}--32`;
}

/**
 * File icon name by file ext
 * @example <el-icon :name="'file1.doc' | fileIcon"></el-icon>
 * @example <el-icon :name="'folder' | fileIcon('folder')"></el-icon>
 * Special icons: 'folder', 'volume'
 */
export default function (value, arg) {
  if (arg) {
    if (arg === 'volume') {
      return getFullSvgIconName(VOLUME_ICON_NAME);
    } else if (arg === 'folder') {
      return getFullSvgIconName(FOLDER_ICON_NAME);
    }
  }

  if (value && value.indexOf('.') > -1) {
    const ext = value.split('.').pop().toLowerCase();
    const iconId = EXT_ICON_ID_MAP.get(ext);
    if (iconId !== undefined && iconId !== null && iconId !== '') {
      return getFullSvgIconName(ICON_NAME[iconId]);
    }
  }
  return getFullSvgIconName(UNDEFINED_ICON_NAME);
}

